export default __webpack_public_path__ + "static/media/skin-condition.546d279d.jpg";